import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";

export const EducacaoAba = ({ children, props, isMobile }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Educação
        </Text>
        {children}
      </Flex>

      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={" Frequenta Escola?"}
          mb={4}
          mt={7}
        >
          Frequenta Escola?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioFrequentaEscola">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioFrequentaEscola &&
                    form.touched.radioFrequentaEscola
                  }
                  id="radioFrequentaEscola"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioFrequentaEscola", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-frequentaEscola-s"
                        fieldName="radioFrequentaEscola"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-frequentaEscola-n"
                        fieldName="radioFrequentaEscola"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioFrequentaEscola}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Educação Especial"}
          mb={4}
          mt={7}
        >
          Educação Especial
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioEducacaoEspecial">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioEducacaoEspecial &&
                    form.touched.radioEducacaoEspecial
                  }
                  id="radioEducacaoEspecial"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioEducacaoEspecial", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-educacaoespecial-s"
                        fieldName="radioEducacaoEspecial"
                        value="S"
                        label="Sim"
                        disabled={props.values.radioFrequentaEscola === "N"}
                      />
                      <RadioButtonField
                        id="radio-educacaoespecial-n"
                        fieldName="radioEducacaoEspecial"
                        value="N"
                        label="Não"
                        disabled={props.values.radioFrequentaEscola === "N"}
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioEducacaoEspecial}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Escolaridade Repetida?"}
          mb={4}
          mt={7}
        >
          Escolaridade Repetida?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioEscolaridadeRepetida">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioEscolaridadeRepetida &&
                    form.touched.radioEscolaridadeRepetida
                  }
                  id="radioEscolaridadeRepetida"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioEscolaridadeRepetida", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-escolaridadeRepetida-s"
                        fieldName="radioEscolaridadeRepetida"
                        value="S"
                        label="Sim"
                        disabled={props.values.radioFrequentaEscola === "N"}
                      />
                      <RadioButtonField
                        id="radio-escolaridadeRepetida-n"
                        fieldName="radioEscolaridadeRepetida"
                        value="N"
                        label="Não"
                        disabled={props.values.radioFrequentaEscola === "N"}
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioEscolaridadeRepetida}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};
